var env = {
    BASE_URL: "https://api2.savlog.net/api",
    // BASE_URL: "http://127.0.0.1:8000/api",
    API_URL: "/service",
    API_ID: "777",
    API_TOKEN: "MlNykMcT78moIEkwtti4qWP0rwYNNCG",
}

export default env
